export default "__VITE_ASSET__BLuLe9Jc__"